
export default function FounderSection() {
  return (
    <section className="section-wrap bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Founder Image */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <img 
                src="/founder.png"
                alt="Sylvia Manthata - Founder"
                className="w-full h-96 lg:h-[500px] object-cover object-top"
              />
            </div>
            {/* Quote Overlay */}
            <div className="absolute -bottom-8 -right-8 bg-[#2D7F3E] text-white p-6 rounded-xl shadow-lg max-w-xs">
              <i className="ri-double-quotes-l text-3xl mb-2 opacity-50"></i>
              <p className="text-sm italic">
                "Skills development is the most powerful investment we can make — in people, in organisations, and in the future."
              </p>
            </div>
          </div>

          {/* Founder Content */}
          <div>
            <h2 className="section-heading">
              Our Founder - Sylvia Manthata
            </h2>
            
            <div className="space-y-6 text-gray-600">
              <p className="text-lg leading-relaxed">
                Sylvia Manthata founded Sylman Consultancy in 2007 with a clear mission: to help organisations unlock the full potential of their people through strategic training and skills development.
              </p>
              
              <p className="text-lg leading-relaxed">
                With over 19 years of experience in education, training, and development across South Africa's private sector, Sylvia brings deep expertise in training needs analysis, skills audits, and the design of targeted interventions that close critical skills gaps. She works closely with clients on Workplace Skills Plans (WSPs) and Annual Training Reports (ATRs), and oversees training delivery to the highest quality management standards aligned with ETQA requirements.
              </p>

              <p className="text-lg leading-relaxed">
                Before founding Sylman, Sylvia honed her craft at some of South Africa's most recognised brands. As Learnership Manager at Shoprite Group of Companies, she led the successful rollout of an 800-learner NQF Level 2 programme in partnership with the Wholesale & Retail SETA. She then served as Training Manager at Famous Brands (Debonairs), where she developed training material and built systems to track and monitor training delivery at scale.
              </p>

              <p className="text-lg leading-relaxed">
                Sylman Consultancy is accredited with the Quality Council for Trades and Occupations (QCTO), Wholesale & Retail SETA as a primary training provider, with extension of scope across TETA, CETA, AgriSETA, Local Government SETA, ETDP SETA, and Services SETA.
              </p>

              <p className="text-lg leading-relaxed">
                Sylvia holds a Bachelor of Technology in Human Resources Management and a National Diploma in Occupationally Directed Education, Training and Development, and is a qualified assessor and moderator.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
